<template>
  <div class="spotlight-video-container">
    <div class="video-inner">
      <iframe id="spotlight-video" :src="videoUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import log from '@/services/log';

export default {
  name: 'SpotlightVideo',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    product: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      hasBeenPlayed: false,
    };
  },
  mounted() {
    const tag = document.createElement('script');
    tag.id = 'iframe-api';
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      // eslint-disable-next-line no-undef
      this.player = new YT.Player('spotlight-video', {
        events: {
          onStateChange: this.onPlayerStateChange,
        },
      });
    };
  },
  computed: {
    videoUrl() {
      const url = new URL(`https://www.youtube.com/embed/${this.videoId}`);
      const params = {
        rel: 0,
        enablejsapi: 1,
        hl: this.$i18n.locale,
        cc_lang_pref: this.$i18n.locale,
      };

      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      });

      return url.toString();
    },
  },
  methods: {
    async onPlayerStateChange(event) {
      const PLAYER_STATE_PLAYING = 1;
      if (event.data === PLAYER_STATE_PLAYING && this.hasBeenPlayed === false) {
        try {
          // Analytics tracking
          const payload = {
            elementInteractedWith: `spotlight.${this.product}.video.play`,
          };
          await this.$store.dispatch('metrics/logModalInteraction', payload);
          this.hasBeenPlayed = true;
        } catch (error) {
          log('Error in logging interaction', error);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.spotlight-video-container {
  background-color: #f0f4f7;
  padding: 0;
  margin: 15px -15px;

  @media screen and (min-width: 576px) {
    margin: 15px 0;
  }
}

.video-inner {
  margin: 0 auto;
  max-width: 629px;
  width: 100%;
  height: 100%;
  min-height: 174px;
  background-color: black;
  color: white;
  text-align: center;
  position: relative;

  @media screen and (min-width: 576px) {
    min-height: 325px;
  }

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
